module.exports = __webpack_public_path__ + "img/02_1_2_3.4b8f9e23.png";